'use client';

import { FC } from 'react';
import Image from 'next/image';
import { getImageUrl } from '@/lib/cdn';

const TRUST_LOGOS = [
  { src: getImageUrl('brand/brand-light-01.svg'), alt: 'Flo' },
  { src: getImageUrl('brand/brand-light-03.svg'), alt: 'AT&T' },
  { src: getImageUrl('brand/brand-light-11.svg'), alt: 'Kajeet' },
  { src: '/images/brand/telekom.svg', alt: 'T-Mobile' },
  { src: '/images/brand/queclink.svg', alt: 'Queclink' },
];

const TrustBar: FC = () => {
  return (
    <section className="py-12 md:py-16">
      <div className="container-fluid px-4 md:px-7.5 mx-auto" style={{ maxWidth: 'clamp(1366px, 85vw, 1800px)' }}>
        {/* Match homepage styling */}
        <div className="px-8 md:px-16 lg:px-24">
          <div className="text-center mb-16">
            <p
              className="text-gray-700"
              style={{ fontSize: 'clamp(1.125rem, 2vw, 2.25rem)' }}
            >
              Trusted by top enterprise companies
            </p>
          </div>

          <div className="flex justify-between items-center w-full">
            {TRUST_LOGOS.map((logo, index) => (
              <Image
                key={`${logo.alt}-${index}`}
                src={logo.src}
                alt={logo.alt}
                width={112}
                height={56}
                className="opacity-65 hover:opacity-100 transition-opacity duration-200 max-w-[80px] md:max-w-[112px]"
                loading="lazy"
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrustBar;
